// src/components/roles/RolesTable/InlineBlockConfirmation.tsx
import React from 'react';
import { Popover, Box, Typography, Button, Paper } from '@mui/material';
import { colors } from '../../../styles/theme/colors';

export interface InlineBlockConfirmationProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onConfirm: () => void;
  onCancel: () => void;
  isBlocking: boolean;
  message?: string;
  actionType?: 'block' | 'unblock';
}

const InlineBlockConfirmation: React.FC<InlineBlockConfirmationProps> = ({
  open,
  anchorEl,
  onClose,
  onConfirm,
  onCancel,
  isBlocking,
  message = '¿Desea bloquear este rol?',
  actionType = 'block',
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        sx: {
          mt: 1,
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          minWidth: 220,
          maxWidth: 280,
        },
      }}
    >
      <Paper
        sx={{
          p: 2,
          backgroundColor: 'white',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            mb: 2,
            color: colors.text.primary,
            fontSize: '0.875rem',
            fontWeight: 500,
          }}
        >
          {message}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            justifyContent: 'flex-end',
          }}
        >
          <Button
            variant="tonal"
            size="small"
            onClick={onCancel}
            disabled={isBlocking}
            sx={{
              minWidth: 70,
              textTransform: 'none',
              fontSize: '0.8125rem',
            }}
          >
            Cancelar
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={onConfirm}
            disabled={isBlocking}
            sx={{
              minWidth: 70,
              textTransform: 'none',
              fontSize: '0.8125rem',
              background:
                actionType === 'unblock'
                  ? `linear-gradient(to right, ${colors.success.main}, ${colors.success.dark})`
                  : `linear-gradient(to right, ${colors.error.main}, ${colors.error.dark})`,
              color: 'white',
              '&:hover': {
                background:
                  actionType === 'unblock'
                    ? `linear-gradient(to right, ${colors.success.dark}, ${colors.success.main})`
                    : `linear-gradient(to right, ${colors.error.dark}, ${colors.error.main})`,
              },
              '&:disabled': {
                opacity: 0.6,
              },
            }}
          >
            {isBlocking ? 'Procesando...' : 'Confirmar'}
          </Button>
        </Box>
      </Paper>
    </Popover>
  );
};

export default InlineBlockConfirmation;
